import React from "react";

const fleetData = [
  {
    name: "13 Seater Tempo Traveller",
    desc: "Perfect for small groups or family trips, our 13-seater Tempo Traveller provides cozy pushback seats, air conditioning, and ample luggage space for a comfortable journey every time.",
    image: "/images/gallery/1.jpg",
  },
  {
    name: "17 Seater Tempo Traveller",
    desc: "Ideal for medium-sized groups, this 17-seater Tempo Traveller offers spacious interiors, comfortable seating, and smooth suspension for school trips, tours, or corporate outings.",
    image: "/images/gallery/2.jpg",
  },
  {
    name: "Luxury Force Urbania",
    desc: "Travel in style with the Luxury Force Urbania — featuring plush reclining seats, modern interiors, premium air conditioning, and elegant design for an unforgettable travel experience.",
    image: "/images/gallery/3.jpg",
  },
  {
    name: "32 Seater Bus",
    desc: "A well-equipped 32-seater bus designed for long-distance tours and corporate travel. With AC comfort, wide windows, and soft seats, it ensures a relaxing and scenic journey.",
    image: "/images/gallery/4.jpg",
  },
  {
    name: "35 Seater Bus",
    desc: "This 35-seater luxury bus combines comfort with space — ideal for large family gatherings, weddings, or group excursions, featuring cushioned seating and full air conditioning.",
    image: "/images/gallery/5.jpg",
  },
  {
    name: "40 Seater Bus",
    desc: "Our 40-seater executive bus is perfect for big groups and long trips. It includes pushback seats, ample legroom, individual AC vents, and large windows for a relaxed ride.",
    image: "/images/gallery/6.jpg",
  },
  {
    name: "45 Seater Bus",
    desc: "Comfort meets capacity in this 45-seater luxury bus — ideal for tours, pilgrimages, or company events, with modern interiors and a smooth, air-conditioned travel experience.",
    image: "/images/gallery/7.jpg",
  },
  {
    name: "50 Seater Bus",
    desc: "Designed for large-scale travel, the 50-seater bus provides unmatched comfort with reclining seats, spacious aisles, and powerful AC — perfect for school, corporate, or group trips.",
    image: "/images/gallery/8.jpg",
  },
  {
    name: "AC Luxury Bus",
    desc: "Experience premium travel with our AC Luxury Bus — featuring pushback seats, ambient lighting, onboard entertainment, and a smooth ride for a truly first-class journey.",
    image: "/images/gallery/9.jpg",
  },
];


const OurFleet = () => {
  return (
    <>
      {/* Header Section */}
        <section className="page-header">
        <div
          className="page-header__bg"
          style={{
            backgroundImage: "url(/images/page-header-bg-1-1.jpg)",
          }}
        ></div>
        <div className="container">
          <div className="page-header__content text-center">
            <h2 className="page-header__title">Our Fleets </h2>
          </div>
        </div>
      </section>

      {/* Fleet Cards */}
      <section className="fleet-section py-5">
        <div className="container">
          <div className="row gy-4">
            {fleetData.map((fleet, index) => (
              <div className="col-md-4" key={index}>
                <div className="fleet-card text-center p-4 h-100">
                  <div className="fleet-img mb-3">
                    <img
                      src={fleet.image}
                      alt={fleet.name}
                      className="img-fluid"
                    />
                  </div>
                  <h5 className="fleet-title">{fleet.name}</h5>
                  <p className="fleet-desc">{fleet.desc}</p>
                  
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default OurFleet;
